<template>
    <v-chip justify-end @click="getDocument()">
        <v-avatar class="red" v-show="!documentTokenLoading">
            <v-icon class="white--text">attach_file</v-icon>

        </v-avatar>
        <v-avatar class="transparent" v-show="documentTokenLoading">
            <v-progress-circular
                    indeterminate
                    color="primary"
            ></v-progress-circular>
        </v-avatar>

        {{documentFilename}}
    </v-chip>
</template>

<script>
    import {API_URL} from '../../store/index'
    import {
        Documents
    } from '../../store/namespace-helper'

    export default {
      name: 'v-document-token-chip',
      model: {
        prop: 'documentToken',
        event: 'change'
      },
      props: {
        documentsId: {
          type: Number,
          default: null
        },
        documentFilename: {
          type: String,
          default: ''
        }
      },
      data () {
        return {
          documentTokenLoading: false
        }
      },
      created () {
      },
      computed: {},
      methods: {
        getDocument () {
          this.documentTokenLoading = true
          this.$store.dispatch(Documents.actions.getDocumentToken, {
            id: this.documentsId,
            filename: this.documentFilename
          }).then(response => {
            this.documentTokenLoading = false
            let link = document.createElement('a')
            console.log('DocumentTokenChip token:')
            console.log(response.data)
            link.href = API_URL + '/documentStore/' + response.data.data.token
            link.target = '_blank'
            link.rel = 'noopener noreferrer'
            link.click()

            this.$emit('change', response.data)
          }).catch(reason => {
            console.log('could not get docuement token:' + reason)
          })
        }
      },
      watch: {}

    }
</script>



// WEBPACK FOOTER //
// src/components/Shared/DocumentTokenChip.vue